import * as consts from '../../constants';

export const changeSidebarType = (sidebarType, isMobile) => {
    return {
        type: consts.LAYOUT.CHANGE_SIDEBAR_TYPE,
        payload: { sidebarType, isMobile }
    };
};